<header>
  <app-header></app-header>
</header>
<main class="py-md-3 main-layout">
  <router-outlet></router-outlet>
</main>

<footer class="bg-white shadow-sm p-2 py-3">
  <div class="container-fluid px-5">
    <div class="row">
      <div class="col-6">
        <div class="">
          <p class="footer-text m-0">
            Copyright © 2021
            <strong
              ><a href="https://www.caratred.com/" target="_blank"
                >caratRED</a
              ></strong
            >. All rights reserved.
          </p>
        </div>
      </div>
      <div class="col-6">
        <span class="float-right">version : <strong>V5-1-1</strong></span>
      </div>
    </div>
  </div>
</footer>
